import SideBar from "./SideBar";
import TopBar from "./TopBar";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useSidebarToggle from "../hooks/useSidebarToggle";

const Layout = ({ children }) => {
  const { toogleSidebar, toggleClass, toggle } = useSidebarToggle();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const superUser = localStorage.getItem("superUser");
    const user = localStorage.getItem("user");
    const publicPaths = ["/login", "/hrms/forgot-password"]; // allow unauth access

    // If no authentication tokens exist, redirect to login
    if (!superUser && !user) {
      if (!publicPaths.includes(location.pathname)) {
        navigate("/login");
      }
    }

    // If user is on login page but already authenticated, redirect to appropriate dashboard
    if (location.pathname === "/login") {
      if (superUser) {
        navigate("/dashboard");
      } else if (user) {
        // Check if it's HRMS user and redirect to HRMS dashboard
        const userData = JSON.parse(user);
        if (userData.role === "HR") {
          navigate("/hrms/dashboard");
        } else if (userData.role === "MANAGER") {
          navigate("/hrms/manager-dashboard");
        } else if (userData.role === "EMPLOYEE") {
          navigate("/hrms/employee-dashboard");
        } else {
          navigate("/dashboard");
        }
      }
    }

    // Role-based access control for HRMS routes
    if (location.pathname.startsWith("/hrms/")) {
      if (!user) {
        navigate("/login");
        return;
      }

      const userData = JSON.parse(user);
      if (
        !userData.role ||
        !["HR", "MANAGER", "EMPLOYEE"].includes(userData.role)
      ) {
        navigate("/login");
        return;
      }
    }
  }, [location.pathname, navigate]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {location.pathname !== "/login" &&
        location.pathname !== "/hrms/forgot-password" && (
          <>
            <TopBar toogleSidebar={toogleSidebar} toggle={toggle} />
            <SideBar
              toggleClass={toggleClass}
              toggle={toggle}
              toogleSidebar={toogleSidebar}
            />
          </>
        )}
      <main
        className={`${
          location.pathname !== "/login" &&
          location.pathname !== "/hrms/forgot-password"
            ? "main_section"
            : "vh-100 vw-100"
        } container-fluid p-4`}
      >
        {children}
      </main>
    </>
  );
};

export default Layout;
